import { render, staticRenderFns } from "./ClubPageComponent.vue?vue&type=template&id=62c37873"
import script from "./ClubPageComponent.vue?vue&type=script&lang=js"
export * from "./ClubPageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports